import { IGetObraChecklistServicoStatisticasUseCase } from "../../../presentation/useCases/read/get_obra_checklist_servico_statisticas_use_case";
import { ObraChecklistServicoEstatisticas } from "../../models/obra_checklist_servico_estatiticas";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraChecklistServicoStatisticasUseCase
 */

export class GetObraChecklistServicoStatisticasUseCase implements IGetObraChecklistServicoStatisticasUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraChecklistServicoStatisticas(
    idObraChecklistServico: number | undefined,
  ): Promise<ObraChecklistServicoEstatisticas> {
    if (idObraChecklistServico === undefined) throw new Error("Id de checklist de serviço invalido!");
    const response = await this.repository.getObraChecklistServicoStatisticas(idObraChecklistServico);
    if (response === null) throw new Error("Falha ao obter estatisticas de checklist de serviço!");
    return response;
  }
}
